import { LucideKanban, LucideList } from 'lucide-react'

import { cn } from '@/_lib/utils'
import { useSearchParams } from '@/features/_hooks/use-search-params'

export enum EViewToggleButtonType {
  KANBAN = 'kanban',
  LIST = 'list',
}

interface ViewToggleButtonProps {
  value: EViewToggleButtonType
}

export function ViewToggleButton({ value }: ViewToggleButtonProps) {
  const { setSearchParam } = useSearchParams()

  return (
    <div className="inline-flex h-9 items-center rounded-md border border-input bg-background">
      <button
        type="button"
        className={cn(
          'inline-flex h-full items-center justify-center rounded-l-md px-2.5 transition-colors',
          value === EViewToggleButtonType.LIST
            ? 'bg-brand-green-primary-5/10 text-brand-green-primary-5'
            : 'text-muted-foreground hover:bg-accent',
        )}
        onClick={() => setSearchParam('view', EViewToggleButtonType.LIST)}
      >
        <LucideList size={16} />
      </button>
      <div className="h-5 w-px bg-border" />
      <button
        type="button"
        className={cn(
          'inline-flex h-full items-center justify-center rounded-r-md px-2.5 transition-colors',
          value === EViewToggleButtonType.KANBAN
            ? 'bg-brand-green-primary-5/10 text-brand-green-primary-5'
            : 'text-muted-foreground hover:bg-accent',
        )}
        onClick={() => setSearchParam('view', EViewToggleButtonType.KANBAN)}
      >
        <LucideKanban size={16} />
      </button>
    </div>
  )
}
